import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { cn } from 'root/src/client/v2/common/helpers/cn';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from 'root/src/client/v2/common/components/ui/tooltip';
import { useRedesignCommandPalette } from 'root/src/client/v2/layout/features/RedesignCommandPalette/redesignCommandPalette.context';
// Resolve the shortcut hint per platform. Starts as 'Ctrl K' (matches SSR), then upgrades to the Mac
// symbol after mount, kept hidden until then so the hint never flashes the wrong key.
const useShortcutHint = () => {
    const [mounted, setMounted] = useState(false);
    const [isMac, setIsMac] = useState(false);
    useEffect(() => {
        setMounted(true);
        const platform = `${navigator.platform || ''} ${navigator.userAgent || ''}`;
        setIsMac(/mac|iphone|ipad|ipod/i.test(platform));
    }, []);
    return { mounted, label: isMac ? '⌘ K' : 'Ctrl K' };
};
// Navbar trigger for the command palette. Full pill (icon + "Search" + shortcut) on desktop, or an
// icon-only button (with tooltip + aria-label) for the tight mobile cluster.
export const RedesignCommandSearchButton = ({ iconOnly = false, className }) => {
    const { openPalette } = useRedesignCommandPalette();
    const { mounted, label } = useShortcutHint();
    if (iconOnly) {
        return (<TooltipProvider delayDuration={200}>
				<Tooltip>
					<TooltipTrigger asChild>
						<button type="button" onClick={openPalette} aria-label="Search" className={cn('flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-white/[0.06] hover:text-foreground', className)}>
							<SearchIcon sx={{ fontSize: 18 }}/>
						</button>
					</TooltipTrigger>
					<TooltipContent>Search</TooltipContent>
				</Tooltip>
			</TooltipProvider>);
    }
    return (<button type="button" onClick={openPalette} aria-label="Search" className={cn('flex items-center gap-2 rounded-lg border border-solid border-white/[0.08] bg-white/[0.03] px-2.5 py-1.5 text-sm text-muted-foreground transition-colors hover:border-white/[0.14] hover:bg-white/[0.06] hover:text-foreground', className)}>
			<SearchIcon sx={{ fontSize: 16 }}/>
			<span className="hidden lg:inline">Search</span>
			<kbd className={cn('hidden items-center rounded border border-solid border-white/[0.1] bg-white/[0.04] px-1.5 py-0.5 font-mono text-[10px] font-medium leading-none text-muted-foreground lg:inline-flex', !mounted && 'opacity-0')}>
				{label}
			</kbd>
		</button>);
};
